import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { CustomerLeafWiseCollectionReport } from './Pages';

export const CustomerLeafWiseCollectionReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={CustomerLeafWiseCollectionReport} />
    </Fragment>
)